export default __webpack_public_path__ + "static/media/eudelegationV_dark.1f0bea6f.png";